import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { SharedModule } from '../../shared/shared.module'
import { CustomProductListModule } from '../custom-product-list/custom-product-list.module'
import { CompareProductsComponent } from './compare-products.component'

@NgModule({
  imports: [CommonModule, CustomProductListModule, SharedModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CompareProductsComponent: {
          component: CompareProductsComponent
        }
      }
    })
  ],
  declarations: [CompareProductsComponent],
  exports: [CompareProductsComponent]
})
export class CompareProductsModule {}
